import React from 'react';
import './PaymentNoticeModal.css';

// A short notice that has to be acknowledged before something proceeds.
// Two callers, deliberately sharing one dialog rather than each growing
// their own:
//
//   SocialEditor    owner-facing, shown once when they first add a
//                   payment method, acknowledged server-side
//   PaymentListItem visitor-facing, shown once per profile per session
//                   before a payment detail is revealed
//
// They differ in audience, copy and where the acknowledgement is stored,
// and in nothing else -- so what is shared is the shape (a block of text
// and one button) and the styling, while every caller-specific decision
// arrives as a prop.
//
// Same position:fixed convention as the picker in SocialEditor.js and
// LeadCaptureModal.js, for the same reason: the markup sits several
// overflow:hidden ancestors deep, and a fixed overlay paints against the
// viewport rather than being clipped by any of them.
//
// No close X, no backdrop dismissal, no Escape. The single button is the
// only way out, so acknowledgement is a deliberate act rather than
// something a stray tap can skip -- which is the point in both cases,
// since each caller does something on the other side of it.
//
// `title` is optional. The visitor notice is one sentence and inventing
// a heading for it would add words nobody chose, so when there is no
// title the dialog is named by `ariaLabel` instead -- a dialog still has
// to announce itself to a screen reader either way.
export default function PaymentNoticeModal({
  title = null,
  ariaLabel = null,
  buttonLabel,
  onAcknowledge,
  children,
}) {
  const titleId = 'payment-notice-title';

  return (
    <div className="payment-notice-backdrop">
      <div
        className="payment-notice"
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        aria-label={title ? undefined : ariaLabel}
      >
        {title && (
          <h4 className="payment-notice__title" id={titleId}>
            {title}
          </h4>
        )}
        <p className="payment-notice__body">{children}</p>
        <button type="button" className="payment-notice__button" onClick={onAcknowledge}>
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
